import React, { useMemo, useEffect, useState, useContext, useRef } from 'react'
import { createFilterOptions } from '@material-ui/lab/Autocomplete'
import {
  TextField,
  MuiThemeProvider,
  Popper,
  Paper,
  MenuItem,
  ClickAwayListener,
  IconButton,
} from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles'
import objectPath from 'object-path'
import { useRouteMatch, useLocation } from 'react-router-dom'
import { DesignContext } from 'contexts/DesignContext'

import { ConfigContext } from 'contexts/ConfigContext'
import CircularProgress from '@mui/material/CircularProgress'
import httpClient from 'utility/httpClient.util'
import { debounceCallback } from 'utility/debounceCallback.util'
import FeatherIcon from 'feather-icons-react'

import { setApi } from 'designer/component/action/Api'
import {
  formatNumber,
  getFieldValue,
  getRowFieldValue,
  getTitleValue,
  truncateDecimal,
} from 'designer/component/action/Data'
import {
  onCallAPIAction,
  onUpdateCondition,
} from 'designer/component/action/condition/Action'
import { getAllApi } from 'designer/component/action/Option'
import cloneDeep from 'clone-deep'

const CustomAutocompleteSearch = (props) => {
  let {
    value,
    uischema,
    config = {},
    labelField,
    setLabelField,
    options,
    setOptions,
    updateData,
    updateMapOther,
    onUpdateRowData,
    rowUpdate,
    isFromTable,
    setIsOnChange,
    fieldName,
    fieldKey,
    tableColumn,
    data,
    error,
    isRequire,
    tableUi,
  } = props
  let {
    isMulti,
    optionType = '',
    isAll,
    allLabel,
    allValue,
    key,
    prependIcon,
    appendIcon,
    prependIconTooltip = null,
    appendIconTooltip = null,
    mapOther,
  } = uischema
  const isFavoriteModal = objectPath.get(props, 'defaultProp.isFavoriteModal')

  const dataValue = isFromTable ? rowUpdate : data
  const {
    isDynamic = false,
    dynamicName = '',
    dynamicIndex = 0,
    dynamicKey,
    dynamicData,
  } = config

  const match = useRouteMatch()
  const location = useLocation()
  const search = location.search || []
  const pathParams = match.params || {}
  const urlSearchParams = new URLSearchParams(search)
  const queryParams = Object.fromEntries([...urlSearchParams]) || {}
  const allParams = { ...pathParams, ...queryParams }

  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    elementAction,
    setElementAction,
    setFieldFormData,
    getCurrentUi,
    isLoadingApi,
    isUiChanged,
    setIsUiChanged,
    searchData,
    setDatasourceValue,
    setFormData,
  } = designContext
  const configContext = useContext(ConfigContext)
  const { layoutType } = configContext.state
  const formData = jsonForm.formData
  const apiOptions = useMemo(() => getAllApi(jsonForm), [])
  const datasourceValue = objectPath.get(designContext, '@datasource')

  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', key])
  let isEnable = objectPath.get(elementAction, ['isEnable', key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  const { joinTitle = '' } = uischema
  let hasOnBlur = objectPath.has(uischema, 'onBlur')

  let { jsonLabel, jsonValue } = uischema
  const list = objectPath.get(uischema, `${optionType}`) || {}
  const {
    limit = null,
    dataKey = '',
    valueKey = {},
    isUseLabelPattern = true,
    fieldTitle,
    isCustomInput,
  } = list
  const optionValue = jsonValue ?? list.optionValue ?? 'value'

  const titleValue = uischema?.titleValue || list?.titleValue

  const valueKeyList = Object.keys(valueKey)
  const [loading, setLoading] = useState(false)
  const [checkCallApi, setCheckCallApi] = useState(false)
  const [otherParamUpdated, setOtherParamUpdated] = useState({})

  const createNewAutocompleteOption = (keyword) => {
    let option = {
      __isNewOption__: true,
    }
    objectPath.set(option, optionValue, keyword)
    objectPath.set(option, `@${optionValue}`, keyword)
    return option
  }

  const isSameAutocompleteKeyword = (option, keyword) => {
    let searchValue = (keyword || '').toString().trim()
    if (!searchValue) return true

    let optionItemValue = objectPath.get(option, optionValue)
    let optionLabelValue = objectPath.get(option, `@${optionValue}`)
    let defaultLabelValue = objectPath.get(option, 'label')

    return [optionItemValue, optionLabelValue, defaultLabelValue].some(
      (value) => (value || '').toString().trim() === searchValue,
    )
  }

  const getOptions = (options, isReturn, keyword) => {
    let newOptions = isAll
      ? [
          {
            label: allLabel,
            [optionValue]: allValue,
            isAll: true,
          },
        ]
      : []
    if (Array.isArray(options)) {
      newOptions = newOptions.concat(options)
    } else if (options && typeof options === 'object') {
      newOptions = newOptions.concat(options)
    } else {
      newOptions = []
    }

    if (Array.isArray(titleValue)) {
      newOptions.map((option) => {
        let titleList = []
        let labelList = []
        let fontColor = ''
        let fontWeight = ''
        let isLockedSelect
        titleValue.forEach(
          ({
            title,
            valueType,
            thousandSeparator,
            precision = 0,
            fontWeight: titleFontWeight,
          }) => {
            let itemFontWeight = titleFontWeight || ''
            let subTitle = []
            title.forEach((title) => {
              let labelValue = title.value
              let isNew = objectPath.get(title, '__isNew__')
              if (!isNew) {
                let hasValue = objectPath.has(option, title.value)
                let value = objectPath.get(option, title.value)
                if (valueType === 'number') {
                  let value = objectPath.get(option, title.value) ?? 0
                  let format = thousandSeparator
                    ? formatNumber(value, precision)
                    : truncateDecimal(value, precision, true)
                  labelValue = format.toString()
                } else if (hasValue && value) {
                  labelValue = objectPath.get(option, title.value)
                } else {
                  labelValue = ''
                }
              }
              subTitle.push(labelValue)
            })
            let label = subTitle.join('')
            fontWeight = itemFontWeight || fontWeight
            titleList.push(label)
            labelList.push({
              label,
              fontColor: '',
              fontWeight: itemFontWeight,
            })
          },
        )
        let labelValue = titleList.join(joinTitle)
        objectPath.set(option, `@${optionValue}`, labelValue)
        objectPath.set(option, '@labelList', labelList)
        objectPath.set(option, '@fontColor', fontColor)
        objectPath.set(option, '@fontWeight', fontWeight)
        if (isLockedSelect) {
          objectPath.set(option, 'isDisabled', fontColor)
        }
        return option
      })
    }

    let searchValue = (keyword || '').toString().trim()
    let hasSearchOption = newOptions.some((option) =>
      isSameAutocompleteKeyword(option, searchValue),
    )
    if (searchValue && !hasSearchOption) {
      newOptions.push(createNewAutocompleteOption(searchValue))
    }

    if (isReturn) {
      return newOptions
    }

    setOptions(newOptions)
  }

  useEffect(() => {
    getOptions(list?.options)
  }, [list?.options, isAll, allLabel, allValue])

  const getInternal = async (keyword, isReturn, optionData) => {
    setLoading(true)
    let responseData
    let designerData = {}
    optionData = optionData ?? list

    let url = setApi(
      {
        ...optionData,
        apiType: 'internal',
        isOption: true,
        jsonForm,
      },
      {
        ...formData,
        ...rowUpdate,
        [uischema.key]: keyword,
        [uischema.field]: keyword,
        [uischema.name]: keyword,
      },
      {
        searchData,
        allParams,
        designerData,
        keyword: {
          [uischema.key || uischema.field]: keyword,
          [uischema.name]: keyword,
        },
      },
    )

    if (url) {
      responseData = await httpClient
        .get(url)
        .then(({ data }) => objectPath.get(data, dataKey))
        .catch(() => null)
      getOptions(responseData, false, keyword)
    }
    setLoading(false)
    if (isReturn) {
      return responseData
    }
  }

  const getExternal = async (keyword, isReturn, optionData) => {
    setLoading(true)
    let designerData = {}
    let responseData
    optionData = optionData ?? list
    let url = setApi(
      {
        ...optionData,
        apiType: 'external',
        api: list.api || list.url,
        jsonForm,
      },
      {
        ...formData,
        ...rowUpdate,
        [uischema.key]: keyword,
        [uischema.field]: keyword,
      },
      {
        allParams,
        designerData,
        keyword: {
          [uischema.key || uischema.field]: keyword,
        },
      },
    )
    if (url) {
      responseData = await httpClient
        .get(url)
        .then(({ data }) => objectPath.get(data, dataKey))
        .catch(() => null)
      getOptions(responseData, false, keyword)
      return responseData
    }
    setLoading(false)
    if (isReturn) {
      return responseData
    }
  }

  const handleInputPath = (keyword = '') => {
    if (optionType === 'core') {
      getInternal(keyword)
    } else if (optionType === 'internal') {
      getInternal(keyword)
    } else if (optionType === 'external') {
      getExternal(keyword)
    }
  }

  const getAutocompleteValue = async (
    keyword,
    { isAutoCreate = true, isReturn = false, optionData, isOption = false },
  ) => {
    let options

    if (optionType === 'core') {
      options = await getInternal(keyword, true, optionData)
    } else if (optionType === 'internal') {
      options = await getInternal(keyword, true, optionData)
    } else if (optionType === 'external') {
      options = await getExternal(keyword, true, optionData)
    }
    if (isOption) {
      return options
    }
    if (options) {
      options = getOptions(options, true, keyword)
      let option = options.find(
        (item) =>
          objectPath.get(item, optionValue) === keyword ||
          objectPath.get(item, optionValue) == keyword,
      )
      if (isReturn) {
        return option
      }
      if (isAutoCreate) {
        if (option) {
          handleSelectPath(option)
        }
        return option
      }
    }
    if (isCustomInput) {
      let option = {}
      objectPath.set(option, optionValue, keyword)
      handleSelectPath(option)
      return option
    }
    return {}
  }

  const callAndUpdateOtherValues = async (keyword) => {
    let responseData

    let hasValue = objectPath.get(dataValue, optionValue)
    let hasTitle = createLabelField(dataValue)
    if (hasValue && hasTitle && keyword === hasValue) {
      handleSelectPath(dataValue)
      updateOtherParam(dataValue)
    } else {
      if (optionType === 'core') {
        responseData = await getInternal(keyword, true)
      } else if (optionType === 'internal') {
        responseData = await getInternal(keyword, true)
      } else if (optionType === 'external') {
        responseData = await getExternal(keyword, true)
      }
      if (responseData) {
        let autocomplete = objectPath.get(responseData, [0]) || {}
        updateOtherParam(autocomplete)
      }
    }
  }

  const updateMapRowOther = (option) => {
    if (mapOther) {
      mapOther.forEach(async ({ field, value }) => {
        let column = tableColumn.find((item) => item.field === field)
        if (column) {
          let { typeField, columnValue } = column
          if (typeField === 'autocomplete') {
            let otherValue = getRowFieldValue(column, option)
            objectPath.set(rowUpdate, `@${field}`, otherValue)
            let fieldValue = objectPath.get(option, field)
            if (field) {
              updateData(fieldValue, `${field}`)
            }
            if (columnValue) {
              updateData(otherValue, `@${columnValue}`)
            }
          } else {
            let otherValue
            if (objectPath.has(option, value)) {
              otherValue = objectPath.get(option, value)
            } else {
              otherValue = objectPath.get(option, field)
            }
            if (objectPath.has(rowUpdate, field)) {
              objectPath.set(rowUpdate, field, otherValue)
              updateData(otherValue, field)
            }
          }
        }
      })
      onUpdateRowData(rowUpdate, { checkCallApi: false })
    }
  }

  const handleSelectPath = (option, freeSolo, checkCallApi = false) => {
    if (option) {
      if (isMulti) {
        let newData = []
        option.forEach((item) => {
          let value
          if (isUseLabelPattern) {
            value = createLabelOption(option)
          } else {
            value = objectPath.get(item, optionValue)
          }
          newData.push(value)
        })
        updateData(newData, fieldName)
        setLabelField(newData)
      } else {
        if (freeSolo) {
          value = option
        } else {
          value = objectPath.get(option, optionValue)
        }
        updateData(value, fieldName)
        createLabelField(option)
      }
    } else {
      if (isFromTable) {
        objectPath.set(rowUpdate, fieldName, option)
        let keyOptions = list.keyOptions
        if (keyOptions) {
          keyOptions.forEach((key) => {
            if (key.startsWith('@')) return
            if (objectPath.has(rowUpdate, `@${key}`)) {
              objectPath.set(rowUpdate, `@${key}`, option)
            }
            if (objectPath.has(rowUpdate, key)) {
              objectPath.set(rowUpdate, key, option)
            }
          })
        }
        updateData(option, fieldName)
      } else {
        updateData(option)
      }
      setLabelField(option)
    }
    setLoading(false)
    if (!isFromTable) {
      objectPath.set(isUiChanged, ['autocompleteOption', fieldKey], option)
      setIsUiChanged(isUiChanged)
    }
    setAutocomplete(option)
    if (isFromTable) {
      updateMapRowOther(option)
    } else {
      if (updateMapOther) {
        updateMapOther(option)
      }
    }
    setCheckCallApi(checkCallApi)
  }

  const updateOtherParam = (autocompleteValue, isOnChange) => {
    let otherValues = objectPath.get(uischema, 'internal.otherValues') || {}

    Object.keys(otherValues).forEach((paramName) => {
      let { field } = objectPath.get(otherValues, [paramName]) || {}
      if (!field) return
      let ui = getCurrentUi(field)
      if (isDynamic) {
        let value = objectPath.get(autocompleteValue, paramName)
        if (isOnChange) {
          let dynamicData = objectPath.get(formData, dynamicName)
          objectPath.set(dynamicData, `${dynamicIndex}.${field}`, value)
          objectPath.set(dynamicData, `${dynamicIndex}.${ui.name}`, value)
          setFieldFormData(`${dynamicName}`, dynamicData)
          objectPath.set(otherParamUpdated, `${field}`, {
            isOnChange,
            value,
            name: field,
            dynamicData,
            dynamicKey,
            dynamicName,
            dynamicIndex,
            isDynamic,
            isMainDynamic: true,
          })
        }
      } else {
        if (ui.key === field) {
          let value = objectPath.get(autocompleteValue, paramName)
          setFieldFormData(ui.key, value)
          setFieldFormData(ui.name, value)
          objectPath.set(formData, ui.key, value)
          objectPath.set(formData, ui.name, value)
          objectPath.set(otherParamUpdated, `${ui.key}`, { value })
          onUpdateCondition(props, designContext, ui.key, formData, {
            isOnChange: true,
          })
        }
      }
    })
    valueKeyList.forEach((paramKey) => {
      let uiName = objectPath.get(valueKey, paramKey)
      let value = objectPath.get(autocompleteValue, paramKey)
      if (isDynamic) {
        let dynamicData = objectPath.get(formData, dynamicName)
        objectPath.set(dynamicData, `${dynamicIndex}.${uiName}`, value)
        setFieldFormData(`${dynamicName}`, dynamicData)
      } else {
        setFieldFormData(uiName, value)
      }
    })
    if (isFromTable) {
      if (updateMapOther) {
        updateMapOther(autocompleteValue)
      }
    }
    checkOtherParamUpdated(otherParamUpdated)
  }

  const checkOtherParamUpdated = (otherParamUpdated) => {
    if (isFromTable) return
    Object.keys(otherParamUpdated).forEach((key) => {
      let { isDynamic } = otherParamUpdated[key]
      if (isDynamic) {
        let status = otherParamUpdated[key]
        onUpdateCondition(props, designContext, key, '', status)
      } else {
        onUpdateCondition(props, designContext, key)
      }
    })
    objectPath.set(isUiChanged, `otherParamUpdated`, otherParamUpdated)
    setIsUiChanged(isUiChanged)
    setOtherParamUpdated(otherParamUpdated)
  }

  const clearOtherParam = () => {
    valueKeyList.forEach((paramKey) => {
      let uiName = objectPath.get(valueKey, paramKey)
      if (isDynamic) {
        setFieldFormData(`${dynamicName}.${dynamicIndex}.${uiName}`, '')
      } else {
        setFieldFormData(uiName, '')
      }
    })
    setIsSelected(false)
  }

  const clearAutocomplete = () => {
    let autocomplete = isMulti ? [] : null
    setAutocomplete(autocomplete)
    setLabelField(undefined)
    clearOtherParam()
  }

  const [autocomplete, setAutocomplete] = useState(isMulti ? [] : null)
  const [isSelected, setIsSelected] = useState(false)

  useEffect(() => {
    let otherValues = objectPath.get(uischema, 'internal.otherValues')
    if (otherValues) {
      let hasOtherValues = Object.keys(otherValues).length > 0
      if (value && hasOtherValues) {
        callAndUpdateOtherValues(value)
      }
    }
  }, [])

  useEffect(() => {
    if (isSelected) {
      updateOtherParam(autocomplete, true)
      setIsSelected(false)
    }
  }, [isSelected])

  useEffect(async () => {
    if (value) {
      let autocomplete = await createAutocompleteRowData(rowUpdate)
      setAutocomplete(autocomplete)
    } else {
      clearAutocomplete()
    }
  }, [value])

  useEffect(() => {
    if (checkCallApi) {
      onUpdateRowData(rowUpdate, { checkCallApi })
      setCheckCallApi(false)
    }
  }, [checkCallApi])

  const createAutocompleteRowData = async (rowUpdate) => {
    let keyword
    let autocomplete
    let labelField
    let column = tableColumn.find((item) => item.field === fieldName)
    if (column) {
      let newRowData = {}
      Object.keys(rowUpdate).forEach((key) => {
        if (key.startsWith('@')) return
        let value = objectPath.get(rowUpdate, key)
        objectPath.set(newRowData, key, value)
      })
      let rowFieldValue = getRowFieldValue(column, newRowData)
      keyword = rowFieldValue
      setLabelField(rowFieldValue)
    } else {
      keyword = objectPath.get(rowUpdate, optionValue)
      autocomplete = await updateAutocompleteValue(keyword, true)
      labelField = createLabelField(autocomplete)
      setLabelField(labelField)
    }
    if (autocomplete) {
    } else {
      autocomplete = {
        [optionValue]: keyword,
      }
    }
    if (mapOther) {
      mapOther.forEach(({ field }) => {
        if (objectPath.has(rowUpdate, `@${field}`)) {
          let itemValue = objectPath.get(rowUpdate, `@${field}`)
          objectPath.set(autocomplete, `@${field}`, itemValue)
        }
        if (objectPath.has(autocomplete, field)) {
          let itemValue = objectPath.get(autocomplete, field)
          objectPath.set(rowUpdate, field, itemValue)
        }
      })
      onUpdateRowData(rowUpdate, { checkCallApi: false })
    }
    return autocomplete
  }

  const updateAutocompleteValue = async (value, isReturn = false) => {
    if (value) {
      if (isMulti) {
        let newData = []
        value.forEach(async (itemValue) => {
          let found = options.find(
            (option) => objectPath.get(option, optionValue) === itemValue,
          )
          if (found) {
            newData.push(found)
          } else {
            let autocomplete = await getAutocompleteValue(value)
            if (autocomplete) {
              newData.push(autocomplete)
            }
          }
        })
        if (isReturn) {
          return newData
        }
        setAutocomplete(newData)
      } else {
        let found = options.find(
          (option) => objectPath.get(option, optionValue) === value,
        )
        if (found) {
          if (isReturn) {
            return found
          }
          handleSelectPath(found)
        } else {
          let hasValue = objectPath.get(dataValue, optionValue)
          let hasTitle = createLabelField(dataValue)
          if (hasValue && hasTitle && hasValue === value) {
            handleSelectPath(dataValue)
          } else {
            let autocomplete = await getAutocompleteValue(value, {
              isAutoCreate: true,
              isReturn,
            })
            let found =
              objectPath.get(autocomplete, optionValue) === value ||
              objectPath.get(autocomplete, optionValue) == value
            if (found) {
              if (isReturn) {
                return autocomplete
              }
              handleSelectPath(autocomplete)
            } else {
              let autocomplete = {}
              objectPath.set(autocomplete, optionValue, value)
              objectPath.set(autocomplete, `@${optionValue}`, value)
              handleSelectPath(autocomplete)
            }
          }
        }
      }
    } else {
      setAutocomplete(isMulti ? [] : null)
      setLabelField(undefined)
    }
  }

  const updateInputAndAutocomplete = async (value) => {
    if (value) {
      getAutocompleteValue(value, { isAutoCreate: false })
    } else {
      setLabelField(undefined)
    }
  }

  const createLabelField = (autocomplete = {}, column = uischema) => {
    let labelField
    if (isUseLabelPattern) {
      labelField = getTitleValue(column, autocomplete)
    } else if (fieldTitle) {
      labelField = getFieldValue(column, autocomplete)
    }
    if (!labelField) {
      return labelField
    }
    if (isFromTable) {
      objectPath.set(autocomplete, `@${optionValue}`, labelField)
      updateData(labelField, `@${optionValue}`)
    } else {
      if (fieldTitle) {
        objectPath.set(autocomplete, `@${optionValue}`, labelField)
        updateData(labelField, `@${optionValue}`)
      }
    }
    setAutocomplete(autocomplete)
    return labelField
  }

  const createLabelOption = (option) => {
    let label = ''
    if (objectPath.has(option, `@${uischema.field}`)) {
      label = objectPath.get(option, `@${uischema.field}`)
    } else if (objectPath.has(option, `@${optionValue}`)) {
      label = objectPath.get(option, `@${optionValue}`)
    } else {
      label = objectPath.get(option, optionValue)
    }
    if (label === undefined || label === null) return ''
    return label
  }

  const filterOptions = useMemo(
    () =>
      createFilterOptions({
        limit: limit ? Number(limit) : null,
      }),
    [limit],
  )
  const autocompleteAnchorRef = useRef(null)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isFieldHovered, setIsFieldHovered] = useState(false)
  const [isFieldFocused, setIsFieldFocused] = useState(false)

  const customFilteredOptions = useMemo(() => {
    let filteredOptions = filterOptions(options || [], {
      inputValue: (labelField || '').toString(),
      getOptionLabel: createLabelOption,
    })

    if (!isMulti || !Array.isArray(autocomplete)) {
      return filteredOptions
    }

    return filteredOptions.filter((option) => {
      let optionItemValue = objectPath.get(option, optionValue)
      return !autocomplete.some(
        (selectedOption) =>
          objectPath.get(selectedOption, optionValue) === optionItemValue,
      )
    })
  }, [autocomplete, filterOptions, isMulti, labelField, optionValue, options])

  const openAutocomplete = () => {
    setIsDropdownOpen(true)
    if (!labelField) {
      handleInputPath(labelField)
    }
  }

  const closeAutocomplete = () => {
    setIsDropdownOpen(false)
    setLoading(false)
  }

  const hasAutocompleteValue = useMemo(() => {
    if (isMulti) {
      return Array.isArray(autocomplete) && autocomplete.length > 0
    }
    return Boolean((labelField || '').toString() || autocomplete)
  }, [autocomplete, isMulti, labelField])

  const isShowClearIcon =
    hasAutocompleteValue && !isReadOnly && (isFieldHovered || isFieldFocused)

  const handleClearAutocomplete = (event) => {
    event.preventDefault()
    event.stopPropagation()
    closeAutocomplete()
    handleSelectPath(isMulti ? [] : null)
    clearOtherParam()
  }

  const handleCustomInputChange = (e) => {
    let value = e.target.value
    let autocomplete = {
      [optionValue]: value,
      [`@${optionValue}`]: value,
    }
    setIsDropdownOpen(true)
    setLabelField(value)
    setAutocomplete(autocomplete)
    updateOtherParam(autocomplete, true)
    if (isFromTable) {
      objectPath.set(rowUpdate, fieldName, value)
      updateData(value, fieldName)
      onUpdateRowData(rowUpdate, { checkCallApi: false })
      updateMapRowOther(autocomplete)
    } else {
      updateData(value)
      if (updateMapOther) {
        updateMapOther(autocomplete)
      }
    }
    debounceCallback(
      updateInputAndAutocomplete,
      [value],
      'on-update-autocomplete',
    )
  }

  const handleCustomOptionSelect = (option) => {
    let selectedValue = option
    if (isMulti) {
      selectedValue = Array.isArray(autocomplete)
        ? autocomplete.concat(option)
        : [option]
    }
    let checkCallApi = true
    handleSelectPath(selectedValue, undefined, checkCallApi)
    updateOtherParam(selectedValue, true)
    closeAutocomplete()
  }

  const borderRadius = useMemo(() => {
    let topLeft = '5px'
    let topRight = '5px'
    let bottomRight = '5px'
    let bottomLeft = '5px'
    if (prependIcon) {
      topLeft = '0px'
      bottomLeft = '0px'
    }
    if (appendIcon) {
      topRight = '0px'
      bottomRight = '0px'
    }
    return `${topLeft} ${topRight} ${bottomRight} ${bottomLeft}`
  }, [prependIcon, appendIcon])

  const colorByTheme = useMemo(
    () => (layoutType === 'dark' ? '#adb7be' : '#495057'),
    [],
  )

  const autocompleteTheme = createTheme({
    overrides: {
      MuiFormControl: {
        root: {
          margin: 0,
          width: '100%',
        },
      },
      MuiInputBase: {
        root: {
          padding: `.54rem 0.75rem !important`,
        },
      },
      MuiAutocomplete: {
        inputRoot: {
          '&&[class*="MuiOutlinedInput-root"]': {
            borderRadius: borderRadius,
            border: error ? 'red 1px solid' : 'unset',
          },
          '&&[class*="MuiOutlinedInput-root"] $input': {
            padding: 0,
            backgroundColor: 'transparent',
            fontSize: '14px',
            color: colorByTheme,
            height: '18px !important',
            minHeight: '18px !important',
          },
        },
        listbox: {
          backgroundColor: 'white',
          border: 'unset',
          borderRadius: 'unset',
        },
        option: {
          backgroundColor: 'white',
          '&[data-focus="true"]': {
            backgroundColor: '#F2F2F2',
          },
          '&[aria-selected="true"]': {
            backgroundColor: '#fff',
          },
        },
      },
    },
  })

  const autocompleteRequire = createTheme({
    overrides: {
      MuiFormControl: {
        root: {
          margin: 0,
        },
      },
      MuiInputBase: {
        root: {
          padding: `.54rem 0.75rem !important`,
        },
      },
      MuiAutocomplete: {
        inputRoot: {
          '&&[class*="MuiOutlinedInput-root"]': {
            borderRadius: borderRadius,
            border: 'red 1px solid',
          },
          '&&[class*="MuiOutlinedInput-root"] $input': {
            padding: 0,
            backgroundColor: 'transparent',
            fontSize: '14px',
            color: colorByTheme,
          },
        },
        listbox: {
          backgroundColor: 'white',
          border: 'unset',
          borderRadius: 'unset',
        },
        option: {
          backgroundColor: 'white',
          '&[data-focus="true"]': {
            backgroundColor: '#F2F2F2',
          },
          '&[aria-selected="true"]': {
            backgroundColor: '#fff',
          },
        },
      },
    },
  })

  return (
    <MuiThemeProvider
      theme={isRequire ? autocompleteRequire : autocompleteTheme}
    >
      <ClickAwayListener onClickAway={closeAutocomplete}>
        <div
          ref={autocompleteAnchorRef}
          className="w-100 p-0"
          onMouseEnter={() => setIsFieldHovered(true)}
          onMouseLeave={() => setIsFieldHovered(false)}
        >
          <TextField
            id={fieldKey}
            name={fieldName}
            variant="outlined"
            placeholder={uischema?.fieldName}
            error={Boolean(error || isRequire)}
            value={(labelField || '').toString()}
            onFocus={() => {
              setIsFieldFocused(true)
              openAutocomplete()
            }}
            onBlur={() => setIsFieldFocused(false)}
            onClick={openAutocomplete}
            onChange={handleCustomInputChange}
            style={{ background: isReadOnly ? '#e9ecef' : '' }}
            disabled={isReadOnly}
            InputProps={{
              style: {
                borderRadius,
                overflow: 'hidden',
              },
              readOnly: isReadOnly,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {isShowClearIcon ? (
                    <IconButton
                      size="medium"
                      onMouseDown={(event) => event.preventDefault()}
                      onClick={handleClearAutocomplete}
                      style={{
                        padding: '0',
                        marginLeft: 4,
                        color: colorByTheme,
                      }}
                    >
                      <FeatherIcon
                        icon="x"
                        size="16"
                        variant="outline-secondary"
                      />
                    </IconButton>
                  ) : null}
                </React.Fragment>
              ),
            }}
            inputProps={{
              style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                padding: 0,
              },
            }}
            onKeyDown={(ev) => {
              if (ev.key === 'Enter') {
                if (hasOnBlur) {
                  setIsSelected(true)
                }
              }
            }}
          />

          {isDropdownOpen && (
            <Paper
              style={{
                maxHeight: 300,
                overflowY: 'auto',
                borderRadius: 0,
                position: 'absolute',
                zIndex: 1300,
              }}
            >
              {customFilteredOptions.map((option, index) => {
                let optionLabel = createLabelOption(option)
                let isNewOption = objectPath.get(option, '__isNewOption__')
                let labelList = objectPath.get(option, '@labelList') || []
                return (
                  <MenuItem
                    key={`${objectPath.get(option, optionValue)}-${index}`}
                    disabled={objectPath.get(option, 'isDisabled')}
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => handleCustomOptionSelect(option)}
                    style={{
                      color:
                        objectPath.get(option, '@fontColor') || colorByTheme,
                      fontWeight:
                        Array.isArray(labelList) && labelList.length > 0
                          ? undefined
                          : objectPath.get(option, '@fontWeight'),
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {isNewOption ? (
                      <span
                        style={{
                          marginRight: 8,
                          padding: '1px 6px',
                          borderRadius: 8,
                          backgroundColor: 'rgb(230, 243, 255)',
                          color: 'rgb(47, 130, 212)',
                          border: '1px solid rgb(47, 130, 212)',
                          fontSize: 11,
                          lineHeight: '16px',
                        }}
                      >
                        <FeatherIcon icon="plus" size="12" />
                        เพิ่มใหม่
                      </span>
                    ) : null}
                    {Array.isArray(labelList) && labelList.length > 0 ? (
                      labelList.map(
                        (
                          {
                            label,
                            fontColor: itemFontColor,
                            fontWeight: itemFontWeight,
                          },
                          labelIndex,
                        ) => (
                          <span
                            key={`autocomplete-option-label-${index}-${labelIndex}`}
                            style={{
                              color: itemFontColor || colorByTheme,
                              fontWeight: itemFontWeight || 'normal',
                            }}
                          >
                            {label}
                          </span>
                        ),
                      )
                    ) : (
                      <span>{optionLabel}</span>
                    )}
                  </MenuItem>
                )
              })}
            </Paper>
          )}
        </div>
      </ClickAwayListener>
    </MuiThemeProvider>
  )
}

export default CustomAutocompleteSearch
